import { TSearchPromosResponse_1 } from '../repositories/newbuilding-promos/v2/search-promos';
import { IListingsUrls } from '../types/listingsUrls';

export const mapListingsUrls = (promosResponse: TSearchPromosResponse_1): IListingsUrls => {
  return {
    mapUrl: promosResponse.newbuildingsListingMapUrl || null,
    listingUrl: promosResponse.newbuildingsListingUrl || null,
  };
};
